import React from "react";
import PropTypes from "prop-types";
import { StyledDatePicker, StyledIconWrap } from "./styled";
import Input from "../Input";
import Icon from "../Icon";
import { useTheme } from "styled-components";
import { default as ReactDatePicker } from "react-datepicker";
import { makeStyles } from "../../utils/styles";
import FormError from "../FormError";

const useStyles = makeStyles((css) => ({
    input: css`
        margin-bottom: 0;
    `,
}));
const DatePicker = ({
    inputProps,
    dayFormat,
    startDate,
    endDate,
    minDate,
    selectsStart,
    selectsEnd,
    selected,
    onChange,
    customStyle,
    disabled,
    error,
    errorText,
    small,
    woIcon,
}) => {
    const theme = useTheme();
    const styles = useStyles();
    return (
        <StyledDatePicker customStyle={customStyle} small={small}>
            <ReactDatePicker
                selected={selected}
                startDate={startDate}
                endDate={endDate}
                minDate={minDate}
                onChange={onChange}
                selectsStart={selectsStart}
                selectsEnd={selectsEnd}
                dayFormat={dayFormat}
                showPopperArrow={false}
                disabled={disabled}
                popperPlacement="top-start"
                locale="pl"
                customInput={
                    <Input
                        error={error}
                        endAdornment={
                            <StyledIconWrap woIcon={woIcon}>
                                <Icon
                                    name="calendar"
                                    fill={theme.colors.purple}
                                />
                            </StyledIconWrap>
                        }
                        customStyle={styles?.input}
                        {...inputProps}
                    />
                }
                dateFormat="dd.MM.yyyy"
            />
            {error && errorText && <FormError>{errorText}</FormError>}
        </StyledDatePicker>
    );
};

DatePicker.propTypes = {
    selected: PropTypes.instanceOf(Date),
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    onChange: PropTypes.func,
    dayFormat: PropTypes.string,
    customStyle: PropTypes.array,
    inputProps: PropTypes.object,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    errorText: PropTypes.string,
};
DatePicker.defaultProps = {
    selected: new Date(),
};

export default React.memo(DatePicker);
